var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 46.667,
    viewBox: "0 0 80 46.667",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Equal-sign",
    d: "M9.667,8a6.667,6.667,0,1,0,0,13.334H76.333A6.667,6.667,0,1,0,76.333,8Zm0,33.333a6.667,6.667,0,1,0,0,13.334H76.333a6.667,6.667,0,1,0,0-13.334Z",
    transform: "translate(-3 -8)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEqual);
export default __webpack_public_path__ + "static/media/equal.4ada9df820084469c55f1387afd7fb60.svg";
export { ForwardRef as ReactComponent };